/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=c9c0efaa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c9c0efaa&lang=less&scoped=true"
import "./App.vue?vue&type=style&index=1&id=c9c0efaa&lang=less"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c0efaa"]])

export default __exports__